<template>
  <el-scrollbar>
    <div class="scrollbar-flex-content">
      <CTable>
        <CTableHead>
          <tr  class="d-flex" :class="`nest${info.part_item_id}`">
            <CTableHeaderCell :style="info.extension_info.cols.length <= 5 ? 'flex:1' : 'width:200px'">
              <CButton
                class="btn-outline-primary text-light"
                v-if="!showChild"
                @click="showChild = !showChild"
              >
                <img src="@/assets/icons/arrow-blue.svg" alt="" />
              </CButton>
              <CButton
                class="btn-outline-primary text-light"
                v-else
                @click="showChild = !showChild"
              >
                <img class="openImg" src="@/assets/icons/arrow-blue.svg" alt="" />
              </CButton>
            </CTableHeaderCell>
            <CTableHeaderCell
              :class="showChild ? '' : 'd-none'"
              v-for="(col, index) in info.extension_info.cols"
              :key="index"
              :style="info.extension_info.cols.length <= 5 ? 'flex:1' : 'width:200px'"
            >
              {{ col.title }}
            </CTableHeaderCell>
          </tr>
        </CTableHead>
        <CTableBody :class="showChild ? '' : 'd-none'">
          <tr class="d-flex" :class="`nest${info.part_item_id}`" v-for="(row, index) in info.extension_info.rows" :key="index">
            <CTableHeaderCell :style="info.extension_info.cols.length <= 5 ? 'flex:1' : 'width:200px'">{{ row.title }} </CTableHeaderCell>
            <CTableDataCell
              :style="info.extension_info.cols.length <= 5 ? 'flex:1' : 'width:200px'"
              v-for="(col, col_index) in info.extension_info.cols"
              :key="col_index"
            >
              <CFormCheck
                type="radio"
                :name="`nest-${info.part_item_id}-row-${index}`"
              />
            </CTableDataCell>
          </tr>
        </CTableBody>
      </CTable>
    </div>
  </el-scrollbar>
</template>

<script>
import { ref, onMounted } from '@vue/runtime-core'
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['isOpen'],
  setup() {
    const showChild = ref(true)
    onMounted(()=>{
      // const tr = document.querySelectorAll(`.nest${props.info.part_item_id}`)
      // if(tr){
      //   const trWidth = props.info.extension_info.cols.length * 250 + 'px';
      //   tr.forEach(e=>{
      //     e.style.width = trWidth
      //   })
      // }
    })
    return {
      showChild,
    }
  },
}
</script>
<style lang="scss" scoped>
.openImg {
  rotate: (180deg);
}
</style>
